import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { Role, CompletedTask_$reflection, Course_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, record_type, array_type, bool_type, option_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Task, toastServerError, Course } from "../ApiClient.jsx";
import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { createObj, equals } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { SkeletonItem, Skeleton, PopoverSurface, PopoverTrigger, Popover, Subtitle2, Caption1, Body1, CardHeader, Button, Link, Text as Text$, Title3, tokens, Image, CardPreview, Card } from "@fluentui/react-components";
import { take, length, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { CheckmarkCircleRegular, CheckmarkLockRegular, QuestionRegular, ClipboardTaskListLtrRegular, TextQuoteRegular, CalendarRegular, LockClosedRegular, CheckmarkRegular, CheckmarkCircleFilled, EditRegular, BookOpenRegular } from "@fluentui/react-icons";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { formatCoursesRoute } from "../QueryParameters.jsx";
import { map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { notFoundView } from "../Helpers.jsx";

class Model extends Record {
    constructor(Course, IsFetchingCourseDetails, UserCompletedTasks, UserIsEligible) {
        super();
        this.Course = Course;
        this.IsFetchingCourseDetails = IsFetchingCourseDetails;
        this.UserCompletedTasks = UserCompletedTasks;
        this.UserIsEligible = UserIsEligible;
    }
}

function Model_$reflection() {
    return record_type("Course.CourseView.Model", [], Model, () => [["Course", option_type(Course_$reflection())], ["IsFetchingCourseDetails", bool_type], ["UserCompletedTasks", array_type(CompletedTask_$reflection())], ["UserIsEligible", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateCourse", "SetIsFetching", "UpdateUserCompletedTasks", "UpdateUserIsEligible"];
    }
}

function Msg_$reflection() {
    return union_type("Course.CourseView.Msg", [], Msg, () => [[["Item", option_type(Course_$reflection())]], [["Item", bool_type]], [["Item", array_type(CompletedTask_$reflection())]], [["Item", bool_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Course, msg.fields[0], model.UserCompletedTasks, model.UserIsEligible);
        case 2:
            return new Model(model.Course, model.IsFetchingCourseDetails, msg.fields[0], model.UserIsEligible);
        case 3:
            return new Model(model.Course, model.IsFetchingCourseDetails, model.UserCompletedTasks, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.IsFetchingCourseDetails, model.UserCompletedTasks, model.UserIsEligible);
    }
}

function init() {
    return new Model(undefined, true, [], false);
}

function Promises_fetchCourse(courseId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Course.GetCourse(courseId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    dispatch(new Msg(1, [false]));
                    break;
                }
                case 2: {
                    dispatch(new Msg(1, [false]));
                    break;
                }
                default:
                    dispatch(new Msg(1, [false]));
            }
        }
        else {
            dispatch(new Msg(0, [res.fields[0]]));
            dispatch(new Msg(1, [false]));
        }
        return res;
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_fetchUserCompletedTasks(dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Task.GetMyCompleted());
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(2, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_checkIsEligible(courseId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Course.CheckOwnEligibility(courseId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(3, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function HeaderCard(headerCardInputProps) {
    let elems_10, el_4, imgHeight, matchValue, imageUrl_1, el, elems, el_2, elems_9, elems_2, elems_1, el_6, el_8, elems_8;
    const model = headerCardInputProps.model;
    const course = headerCardInputProps.course;
    const patternInput = useCtx();
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const el_52 = Card;
    return createElement(el_52, createObj(ofArray([["style", createObj(toList(delay(() => append(!isMobile ? singleton(["minHeight", 35 + "vh"]) : empty(), delay(() => append(singleton(["display", "flex"]), delay(() => append(isMobile ? singleton(["flexDirection", "column"]) : empty(), delay(() => append(singleton(["padding", 0]), delay(() => append(singleton(["minWidth", 0]), delay(() => singleton(["overflow", "hidden"]))))))))))))))], (elems_10 = [(el_4 = CardPreview, createElement(el_4, {
        children: (imgHeight = (isMobile ? (120 + "px") : (15 + "vh")), (matchValue = course.ImageUrl, (matchValue != null) ? (!isNullOrWhiteSpace(matchValue) ? ((imageUrl_1 = matchValue, (el = Image, createElement(el, {
            style: createObj(toList(delay(() => append(singleton(["height", imgHeight]), delay(() => (isMobile ? append(singleton(["width", 100 + "%"]), delay(() => singleton(["objectFit", "cover"]))) : empty())))))),
            fit: "cover",
            src: imageUrl_1,
        })))) : createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["height", imgHeight]), delay(() => append(isMobile ? singleton(["width", 100 + "%"]) : empty(), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => singleton(["backgroundColor", tokens.colorNeutralBackground3]))))))))))))))], (elems = [(el_2 = BookOpenRegular, createElement(el_2, {
            style: {
                fontSize: (isMobile ? 56 : 96) + "px",
            },
            primaryFill: tokens.colorNeutralForeground3,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["height", imgHeight]), delay(() => append(isMobile ? singleton(["width", 100 + "%"]) : empty(), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => singleton(["backgroundColor", tokens.colorNeutralBackground3]))))))))))))))], (elems = [(el_2 = BookOpenRegular, createElement(el_2, {
            style: {
                fontSize: (isMobile ? 56 : 96) + "px",
            },
            primaryFill: tokens.colorNeutralForeground3,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))))),
    })), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexGrow", 1]), delay(() => append(singleton(["padding", 15]), delay(() => append(singleton(["gap", 15 + "px "]), delay(() => {
        const matchValue_1 = screenSize;
        switch (matchValue_1.tag) {
            case 0:
            case 1:
                return singleton(["flexDirection", "column"]);
            default:
                return append(singleton(["flexDirection", "row"]), delay(() => append(singleton(["flexWrap", "wrap"]), delay(() => singleton(["justifyContent", "space-between"])))));
        }
    })))))))))))], (elems_9 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => {
        let matchValue_2;
        return append((matchValue_2 = screenSize, (matchValue_2.tag === 0) ? singleton(["width", 100 + "%"]) : ((matchValue_2.tag === 1) ? singleton(["width", 100 + "%"]) : singleton(["maxWidth", 60 + "%"]))), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["gap", 20 + "px "]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => singleton(["justifyContent", "space-between"])))))))));
    })))], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems_1 = [(el_6 = Title3, createElement(el_6, {
        children: course.Name,
    })), (el_8 = Text$, createElement(el_8, {
        children: course.Summary,
        style: {
            color: tokens.colorNeutralForeground3,
        },
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["justifyContent", "flex-start"]), delay(() => append(singleton(["alignItems", "end"]), delay(() => {
        let matchValue_3;
        return append((matchValue_3 = screenSize, (matchValue_3.tag === 0) ? singleton(["flexGrow", 1]) : ((matchValue_3.tag === 1) ? singleton(["flexGrow", 1]) : (empty()))), delay(() => append(singleton(["gap", 10 + "px "]), delay(() => singleton(["minHeight", 100 + "%"])))));
    })))))))))))], (elems_8 = toList(delay(() => {
        let el_14, elems_3, el_12, el_10, el_24, elems_4, el_20, el_16, el_18, el_22, el_34, elems_5, el_30, el_26, el_28, el_32, el_44, elems_6, el_40, el_36, el_38, el_42;
        return append(equals(patternInput[0].User.Role, new Role(1, [])) ? singleton((el_14 = Link, createElement(el_14, createObj(ofArray([["style", {
            width: 100 + "%",
        }], ["href", RouterModule_encodeParts(ofArray(["laeringslop", "bygger", "kurs"]), 1)], (elems_3 = [(el_12 = Button, createElement(el_12, {
            style: {
                width: 100 + "%",
            },
            icon: (el_10 = EditRegular, createElement(el_10, {})),
            children: "Rediger",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))) : (((course.Tasks.length > 0) && course.Tasks.every((task) => model.UserCompletedTasks.some((completedTask) => (completedTask.Task.Id === task.Id)))) ? singleton((el_24 = Card, createElement(el_24, createObj(ofArray([["appearance", "filled-alternative"], ["style", createObj(toList(delay(() => append(singleton(["backgroundColor", tokens.colorPaletteLightGreenBackground2]), delay(() => append(singleton(["border", (((1 + "px ") + "solid") + " ") + tokens.colorStatusSuccessForegroundInverted]), delay(() => append(singleton(["maxWidth", 250]), delay(() => {
            const matchValue_4 = screenSize;
            switch (matchValue_4.tag) {
                case 0:
                case 1:
                    return singleton(["minWidth", 100 + "%"]);
                default: {
                    return empty();
                }
            }
        })))))))))], (elems_4 = [(el_20 = CardHeader, createElement(el_20, {
            image: (el_16 = CheckmarkCircleFilled, createElement(el_16, {
                fontSize: 20,
                primaryFill: tokens.colorStatusSuccessForeground1,
            })),
            header: (el_18 = Body1, createElement(el_18, {
                children: "Fullført",
            })),
        })), (el_22 = Caption1, createElement(el_22, {
            children: "Du har fullført dette kurset",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))) : (model.UserIsEligible ? singleton((el_34 = Card, createElement(el_34, createObj(ofArray([["appearance", "filled-alternative"], ["style", createObj(toList(delay(() => append(singleton(["backgroundColor", tokens.colorBrandBackground2Hover]), delay(() => append(singleton(["border", (((1 + "px ") + "solid") + " ") + tokens.colorBrandStroke1]), delay(() => append(singleton(["maxWidth", 250]), delay(() => {
            const matchValue_5 = screenSize;
            switch (matchValue_5.tag) {
                case 0:
                case 1:
                    return singleton(["minWidth", 100 + "%"]);
                default: {
                    return empty();
                }
            }
        })))))))))], (elems_5 = [(el_30 = CardHeader, createElement(el_30, {
            image: (el_26 = CheckmarkRegular, createElement(el_26, {
                fontSize: 20,
                primaryFill: tokens.colorBrandForeground1,
            })),
            header: (el_28 = Body1, createElement(el_28, {
                children: "Tilgjengelig",
            })),
        })), (el_32 = Caption1, createElement(el_32, {
            children: "Du har tilgang til å ta dette kurset",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))) : singleton((el_44 = Card, createElement(el_44, createObj(ofArray([["appearance", "outline"], ["style", createObj(toList(delay(() => append(singleton(["maxWidth", 250]), delay(() => {
            const matchValue_6 = screenSize;
            switch (matchValue_6.tag) {
                case 0:
                case 1:
                    return singleton(["minWidth", 100 + "%"]);
                default: {
                    return empty();
                }
            }
        })))))], (elems_6 = [(el_40 = CardHeader, createElement(el_40, {
            image: (el_36 = LockClosedRegular, createElement(el_36, {
                fontSize: 20,
            })),
            header: (el_38 = Body1, createElement(el_38, {
                children: "Ikke tilgjengelig",
            })),
        })), (el_42 = Caption1, createElement(el_42, {
            children: "Dette kurset er på et nivå du ikke har tilgang til enda",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))))), delay(() => {
            let el_50, elems_7, el_48, el_46;
            return singleton((el_50 = Link, createElement(el_50, createObj(ofArray([["style", {
                width: 100 + "%",
            }], ["href", formatCoursesRoute(new Int32Array([course.Id]))], (elems_7 = [(el_48 = Button, createElement(el_48, {
                style: {
                    width: 100 + "%",
                },
                children: "Se datoer",
                icon: (el_46 = CalendarRegular, createElement(el_46, {})),
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])])));
}

function AboutCourse(description) {
    let elems, el_4, el, el_2, el_6;
    const el_8 = Card;
    return createElement(el_8, createObj(ofArray([["size", "large"], (elems = [(el_4 = CardHeader, createElement(el_4, {
        image: (el = TextQuoteRegular, createElement(el, {
            fontSize: 32,
        })),
        header: (el_2 = Subtitle2, createElement(el_2, {
            children: "Om kurset",
        })),
    })), (el_6 = Body1, createElement(el_6, {
        children: description,
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

function TaskList(taskListInputProps) {
    let elems_3;
    const model = taskListInputProps.model;
    const course = taskListInputProps.course;
    const isMobile = equals(useFeliz_React__React_useResponsive_Static_Z434A9929(), new ScreenSize(0, []));
    const el_34 = Card;
    return createElement(el_34, createObj(ofArray([["size", "large"], (elems_3 = toList(delay(() => {
        let el_18, el, el_2, el_16;
        return append(singleton((el_18 = CardHeader, createElement(el_18, {
            image: (el = ClipboardTaskListLtrRegular, createElement(el, {
                fontSize: 32,
            })),
            header: (el_2 = Subtitle2, createElement(el_2, {
                children: "Oppgaver",
            })),
            action: (el_16 = Popover, createElement(el_16, createObj(toList(delay(() => append(isMobile ? singleton(["positioning", "below-start"]) : singleton(["positioning", "before"]), delay(() => {
                let elems_1, el_8, el_6, el_4, el_14, elems, el_10, text_2, el_12, elemsToUse;
                return singleton((elems_1 = [(el_8 = PopoverTrigger, createElement(el_8, {
                    children: (el_6 = Button, createElement(el_6, {
                        icon: (el_4 = QuestionRegular, createElement(el_4, {})),
                        appearance: "subtle",
                    })),
                })), (el_14 = PopoverSurface, createElement(el_14, createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: isMobile ? (75 + "vw") : (400 + "px"),
                }], (elems = [(el_10 = Subtitle2, createElement(el_10, {
                    children: "Godkjenning av oppgaver",
                })), (text_2 = "Hvis kurset inneholder oppgaver du selv kan markere som fullført, vises en avkrysningsboks ved disse. For øvrige oppgaver er det kursholder som må godkjenne gjennomføringen.", (el_12 = Caption1, createElement(el_12, {
                    children: text_2,
                })))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], (elemsToUse = ((length(elems_1) <= 2) ? elems_1 : take(2, elems_1)), ["children", reactApi_1.Children.toArray(elemsToUse)])));
            }))))))),
        }))), delay(() => map((task) => {
            const userHasCompleted = model.UserCompletedTasks.some((completedTask) => (completedTask.Task.Id === task.Id));
            const el_32 = Card;
            return createElement(el_32, createObj(toList(delay(() => append(singleton(["appearance", "subtle"]), delay(() => append(!isMobile ? singleton(["orientation", "horizontal"]) : empty(), delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["id", `${task.Id}`]), delay(() => {
                let elems_2;
                return singleton((elems_2 = toList(delay(() => {
                    let el_28;
                    return append(singleton((el_28 = CardHeader, createElement(el_28, createObj(toList(delay(() => append(singleton(["image", (task.VerificationRequired ? ((props_27) => {
                        const el_20 = CheckmarkLockRegular;
                        return createElement(el_20, createObj(props_27));
                    }) : ((props_31) => {
                        const el_22 = CheckmarkCircleRegular;
                        return createElement(el_22, createObj(props_31));
                    }))(toList(delay(() => append(userHasCompleted ? singleton(["primaryFill", tokens.colorStatusSuccessForeground1]) : singleton(["primaryFill", tokens.colorNeutralForeground3]), delay(() => singleton(["fontSize", 24]))))))]), delay(() => {
                        let el_24;
                        return append(singleton(["header", (el_24 = Body1, createElement(el_24, {
                            children: task.Name,
                        }))]), delay(() => {
                            let el_26;
                            return !isMobile ? singleton(["description", (el_26 = Caption1, createElement(el_26, {
                                children: task.Description,
                            }))]) : empty();
                        }));
                    })))))))), delay(() => {
                        let el_30;
                        return isMobile ? singleton((el_30 = Caption1, createElement(el_30, {
                            children: task.Description,
                        }))) : empty();
                    }));
                })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))]));
            }))))))))))));
        }, course.Tasks)));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])));
}

export function View(viewInputProps) {
    let elems_1, elems, el, el_2, el_4;
    const courseId = viewInputProps.courseId;
    const setCtx = useCtx()[1];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffectOnce(() => {
        Promises_fetchCourse(courseId, dispatch, setCtx);
        Promises_fetchUserCompletedTasks(dispatch, setCtx);
        Promises_checkIsEligible(courseId, dispatch, setCtx);
    });
    const matchValue = model_1.Course;
    if (matchValue != null) {
        const course = matchValue;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 2 + "rem",
        }], (elems_1 = toList(delay(() => append(singleton(createElement(HeaderCard, {
            course: course,
            model: model_1,
        })), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = course.Description, (matchValue_1 != null) ? singleton(AboutCourse(matchValue_1)) : singleton(defaultOf())), delay(() => singleton(createElement(TaskList, {
                course: course,
                model: model_1,
            }))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
    else if (model_1.IsFetchingCourseDetails) {
        const el_6 = Skeleton;
        return createElement(el_6, createObj(ofArray([["style", {
            width: 100 + "%",
            display: "flex",
            flexDirection: "column",
            gap: 25 + "px ",
        }], (elems = [(el = SkeletonItem, createElement(el, {
            style: {
                height: 35 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        })), (el_2 = SkeletonItem, createElement(el_2, {
            style: {
                height: 20 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        })), (el_4 = SkeletonItem, createElement(el_4, {
            style: {
                height: 20 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
    }
    else {
        return notFoundView();
    }
}

//# sourceMappingURL=CourseView.jsx.map
